import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { DefeitoPallet, SeveridadeDefeito } from '../../types/qualidade';
import { defeitosService } from '../../services';

const severidadeOptions: { label: string; value: SeveridadeDefeito }[] = [
  { label: 'Baixa', value: 'BAIXA' },
  { label: 'Média', value: 'MEDIA' },
  { label: 'Alta', value: 'ALTA' },
  { label: 'Crítica', value: 'CRITICA' },
];

const fields: ResourceField<DefeitoPallet>[] = [
  { name: 'codigo', label: 'Código', required: true },
  { name: 'descricao', label: 'Descrição', required: true },
  { name: 'severidade', label: 'Severidade', type: 'select', options: severidadeOptions },
];

export const DefeitosFormPage: React.FC = () => (
  <ResourceFormPage
    title="Registrar defeito"
    description="Detalhe o defeito encontrado."
    fields={fields}
    service={defeitosService}
    redirectPath="/admin/qualidade/defeitos"
    cancelPath="/admin/qualidade/defeitos"
  />
);
